const gimmickMatchUnlocksData = {'Ladder': ['Tables', 'TLC'], 'Street Fight': ['Unsanctioned', 'LMS', 'Ambulance'],
                              'Steel Cage': ['Steel Cell', 'Hell In A Cell'], 'Submission': ['Loser Leaves'],
                              'Pole': ['Flag'], 'Ironman': ['Brawl', 'Casket'],
                              'Graphene Cage': ['Graphene Cell'], 'Glacier Escape': ['Spaceflight'],
                              'Canyon Fight': ['Chemical Warfare']};

export {gimmickMatchUnlocksData}